export const PASARGADREPORT_LIST_REQUEST = 'PASARGADREPORT_LIST_REQUEST'
export const PASARGADREPORT_LIST_SUCCESS = 'PASARGADREPORT_LIST_SUCCESS'
export const PASARGADREPORT_LIST_FAIL = 'PASARGADREPORT_LIST_FAIL'

export const PASARGADINQUIRY_LIST_REQUEST = 'PASARGADINQUIRY_LIST_REQUEST'
export const PASARGADINQUIRY_LIST_SUCCESS = 'PASARGADINQUIRY_LIST_SUCCESS'
export const PASARGADINQUIRY_LIST_FAIL = 'PASARGADINQUIRY_LIST_FAIL'

